import { render } from "./newOrder.vue?vue&type=template&id=3e4ae73a&scoped=true"
import script from "./newOrder.vue?vue&type=script&lang=js"
export * from "./newOrder.vue?vue&type=script&lang=js"

import "./newOrder.vue?vue&type=style&index=0&id=3e4ae73a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4ae73a"]])

export default __exports__